import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-white mt-16">
      <div className="container">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 py-12">
          {/* About Section */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold mb-4">About Career Foundation</h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              Career Foundation is the Best Coaching Center for Jharkhand Govt. Exams Preparation.
              We provide quality online education and test series.
            </p>
            <div className="flex gap-4 mt-6">
              <a 
                href="https://www.youtube.com/@CareerFoundation" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-2xl hover:text-red-500 transition"
              >
                <i className="fab fa-youtube"></i> 🎥
              </a>
              <a 
                href="https://www.facebook.com/careerfoundation" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-2xl hover:text-blue-500 transition"
              >
                <i className="fab fa-facebook"></i> 📘
              </a>
              <a 
                href="https://www.instagram.com/careerfoundation" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-2xl hover:text-pink-500 transition"
              >
                <i className="fab fa-instagram"></i> 📷
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/courses" className="text-gray-300 hover:text-white transition">
                  Courses
                </Link>
              </li>
              <li>
                <Link to="/about-us" className="text-gray-300 hover:text-white transition">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="text-gray-300 hover:text-white transition">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/test-series" className="text-gray-300 hover:text-white transition">
                  Test Series
                </Link>
              </li>
            </ul>
          </div>

          {/* Popular Courses */}
          <div>
            <h3 className="text-xl font-bold mb-4">Popular Courses</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/courses" className="text-gray-300 hover:text-white transition">
                  JPSC
                </Link>
              </li>
              <li>
                <Link to="/courses" className="text-gray-300 hover:text-white transition">
                  JSSC CGL
                </Link>
              </li>
              <li>
                <Link to="/courses" className="text-gray-300 hover:text-white transition">
                  JSSC Excise Constable
                </Link>
              </li>
              <li>
                <Link to="/courses" className="text-gray-300 hover:text-white transition">
                  Jharkhand Polytechnic
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contact Info</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3 text-gray-300">
                <span className="text-lg">📍</span>
                <span>Ranchi, Jharkhand, India</span>
              </li>
              <li className="flex items-center gap-3 text-gray-300">
                <span className="text-lg">📞</span>
                <span>+91-9835508812</span>
              </li>
              <li className="flex items-center gap-3 text-gray-300">
                <span className="text-lg">📧</span>
                <span className="break-all">info@careerfoundation.org.in</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-gray-700 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-gray-300">
            <p className="text-center sm:text-left">
              &copy; {currentYear} Career Foundation. All Rights Reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy-policy" className="hover:text-white transition">
                Privacy Policy
              </Link>
              <Link to="/terms-conditions" className="hover:text-white transition">
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
